export default __webpack_public_path__ + "static/media/origon-logo.80d237ee.png";